/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BookingStrictHttpResponse } from '../../booking-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BookingDetailModel } from '../../models/booking-detail-model';

export interface HealthFindrBookingDetailUrnBookingIdGet$Params {
  urnBookingId: string;
}

export function healthFindrBookingDetailUrnBookingIdGet(http: HttpClient, rootUrl: string, params: HealthFindrBookingDetailUrnBookingIdGet$Params, context?: HttpContext): Observable<BookingStrictHttpResponse<BookingDetailModel>> {
  const rb = new RequestBuilder(rootUrl, healthFindrBookingDetailUrnBookingIdGet.PATH, 'get');
  if (params) {
    rb.path('urnBookingId', params.urnBookingId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BookingStrictHttpResponse<BookingDetailModel>;
    })
  );
}

healthFindrBookingDetailUrnBookingIdGet.PATH = '/HealthFindr/BookingDetail/{urnBookingId}';
